import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger.js";

gsap.registerPlugin(ScrollTrigger);

// bg-color transition


if (document.querySelector('.bg-color-transition')) {
	let bgColorSection = '.bg-color-transition'
	let startTriggers = '.bg-color-transition-start'
	let endTriggers = '.bg-color-transition-end'
	let heroStartTrigger = '.bg-color-transition-start--hero'


	let colorChangeHero = gsap.fromTo(bgColorSection, { background: "linear-gradient(to bottom right, #fff 0%, #F2B399 50%)"},{ background: "linear-gradient(to bottom, #F2B399, #F2B399)"});
	let colorChange = gsap.fromTo(bgColorSection, { background: "linear-gradient(to bottom, #fff, #fff)"},{ background: "linear-gradient(to bottom, #F2B399, #F2B399)"});
	let colorToWhite = gsap.fromTo(bgColorSection, { background: "linear-gradient(to bottom, #F2B399, #F2B399)" },{ background: "linear-gradient(to bottom, #fff, #fff)"});

	ScrollTrigger.create({
	  trigger: heroStartTrigger,
	  start: "top-=1000 top+=200",
	  end: "+=900px",
	  scrub: true,
	  animation: colorChangeHero
	  // onEnter: () =>
	  //  gsap.to(bgColorSection, { backgroundColor: "#232E3E", overwrite: "auto" }),
	  // onLeaveBack: () =>
	  //  gsap.to(bgColorSection, { backgroundColor: "white", overwrite: "auto" })
	});


	gsap.utils.toArray(startTriggers).forEach((startTrigger) => {
	// startTriggers.forEach( startTrigger => {

	  ScrollTrigger.create({
	    trigger: startTrigger,
	    start: "top-=100 top+=200",
	    end: "+=900px",
	    scrub: true,
	    animation: colorChange
	    // onEnter: () =>
	    //  gsap.to(bgColorSection, { backgroundColor: "#232E3E", overwrite: "auto" }),
	    // onLeaveBack: () =>
	    //  gsap.to(bgColorSection, { backgroundColor: "white", overwrite: "auto" })
	  });

	});

	gsap.utils.toArray(endTriggers).forEach((endTrigger) => {
	// endTriggers.forEach( endTrigger => {

	  ScrollTrigger.create({
	    trigger: endTrigger,
	    start: "top-=800",
	    end: "+=700",
	    scrub: true,
	    animation: colorToWhite
	    // onEnter: () =>
	    //  gsap.to(bgColorSectionn, { backgroundColor: "#232E3E", overwrite: "auto" }),
	    // onLeaveBack: () =>
	    //  gsap.to(bgColorSection, { backgroundColor: "white", overwrite: "auto" })
	  });

	});

}